import { useEffect, useState } from 'react';
import { SIGNUP_STEPS } from '../../../types/enum';
import request from '../../../lib/request';
import TextSelect from '../../../components/textSelect';

const Nationality = ({ country, setCountry, setCurrentStep }) => {
  const [countryList, setCountryList] = useState([]);

  useEffect(() => {
    getCountryList();
  }, []);

  const getCountryList = async () => {
    try {
      const { result } = await request.get('/signup/static-country');

      if (result) {
        setCountryList([{ flag: '', name: 'Unknown' }, ...result]);
      }
    } catch (err) {
      console.log(err?.message);
    }
  };

  const handleInput = (e) => {
    const value = String(e.target.value);
    setCountry(value);
  };

  const handleNext = () => {
    try {
      setCurrentStep(SIGNUP_STEPS.EMAIL);
    } catch (err) {
      alert(err.message);
    }
  };

  return (
    <div>
      <h1 className='font-bold mb-3 text-white text-4xl'>
        What's your nationality?
      </h1>
      <div className='mb-5'>
        <select
          className='w-full bg-white rounded-full py-3 px-4 '
          onChange={handleInput}
          value={country ?? ''}
        >
          <option
            value=''
            disabled
          >
            Select Country
          </option>
          {countryList.map(({ flag, name }) => (
            <option
              key={name}
              value={name}
            >
              {`${name} ${flag}`}
            </option>
          ))}
        </select>
      </div>
      <button
        className={`w-full bg-yellow-500 text-black font-bold rounded-full hover:bg-yellow-600 transition-colors duration-200 py-3 ${
          !country
            ? 'opacity-40'
            : 'hover:bg-yellow-600 transition-colors duration-200'
        }`}
        onClick={handleNext}
        disabled={!country}
      >
        Next
      </button>
    </div>
  );
};

export default Nationality;
